import React from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

// Данные не загрузились (сервер не ответил или ответил ошибкой): вместо пустой таблицы
// или вечной загрузки человек видит, что случилось, и может повторить запрос.
function LoadError({ onRetry, title = 'Не удалось загрузить данные', hint = 'Проверьте соединение или попробуйте ещё раз.' }) {
  return (
    <Paper style={{ padding: '32px 24px', textAlign: 'center' }} role="alert">
      <ErrorOutlineIcon color="error" style={{ fontSize: 40 }} />
      <Typography variant="h6" style={{ marginTop: 8 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
        {hint}
      </Typography>
      <Button variant="contained" color="primary" disableElevation onClick={onRetry}>
        Повторить
      </Button>
    </Paper>
  );
}

export default LoadError;
